import EditInvoiceRate from './EditInvoiceRate';
export default EditInvoiceRate;